(() => {
  const initializeEarlyAccess = (root) => {
    if (!root || root.dataset.earlyAccessReady === 'true') return;
    root.dataset.earlyAccessReady = 'true';

    const countdown = root.querySelector('[data-countdown]');
    const passwordAccess = root.querySelector('[data-password-access]');
    const targetTime = Date.parse(root.dataset.countdownTarget || '');
    const hasPasswordError = Boolean(passwordAccess?.querySelector('[role="alert"]'));
    let timerId;

    const showPassword = () => {
      if (timerId) window.clearInterval(timerId);
      countdown?.setAttribute('hidden', '');
      passwordAccess?.removeAttribute('hidden');
    };

    const updateCountdown = () => {
      const remaining = targetTime - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        showPassword();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      };

      Object.entries(values).forEach(([unit, value]) => {
        const output = root.querySelector(`[data-countdown-${unit}]`);
        if (output) output.textContent = String(value).padStart(2, '0');
      });
    };

    if (hasPasswordError) {
      showPassword();
    } else {
      updateCountdown();
      if (passwordAccess?.hasAttribute('hidden')) timerId = window.setInterval(updateCountdown, 1000);
    }

    const dialog = root.querySelector('[data-newsletter-dialog]');
    const openButton = root.querySelector('[data-newsletter-open]');
    const closeButton = root.querySelector('[data-newsletter-close]');

    openButton?.addEventListener('click', () => {
      if (dialog && !dialog.open) dialog.showModal();
    });
    closeButton?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    if (dialog?.querySelector('[role="alert"], [role="status"]') && !dialog.open) dialog.showModal();
  };

  document.querySelectorAll('[data-early-access]').forEach(initializeEarlyAccess);
  document.addEventListener('shopify:section:load', (event) => {
    initializeEarlyAccess(event.target.querySelector('[data-early-access]'));
  });
})();
